import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  text: {
    fontSize: '20px !important',
    fontWeight: '700'
  },
  selectPlaceholder: {
    paddingLeft: 8
  },
  tag: {
    border: 0,
    backgroundColor: '#E7F3FB',
    color: token.colorPrimary,
    borderRadius: 16,
    padding: '4px 10px 4px 12px',

    '.ant-tag-close-icon': {
      color: 'inherit ',
      ':hover': {
        color: 'inherit'
      }
    }
  },
  textareaText: {
    alignSelf: 'flex-end'
  },
  textarea: {
    maxHeight: 150
  },
  requiredMark: {
    color: token.colorError
  },
  buttonIcon: {
    color: token.colorPrimary
  }
}))
